import { Component } from '@angular/core';

import { IAdvancedFormEvent, AdvancedFormEventTypes } from '~shared/modules/advanced-form/models/advanced-form.model';
import { BadRequestHttpError } from '~shared/modules/error-handler';

import { CHANGE_PASSWORD_FORM_CONFIG } from '../../constants/change-password.constant';
import { AccountManagementService } from '../../services/account-management.service';
import { IChangePasswordData } from '../../models/account-info.model';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent {
  public advancedFormConfig = CHANGE_PASSWORD_FORM_CONFIG;

  constructor(
    private accountManagementService: AccountManagementService,
  ) {}

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    if (event.type === AdvancedFormEventTypes.submit) {
      const changePasswordData = event.payload.formData as IChangePasswordData;
      this.accountManagementService.changePassword(changePasswordData).subscribe(
        () => event.done(),
        (error: BadRequestHttpError) => event.done(error.invalidParams),
      );
    }
  }
}
